'use client';

import { GlobalLoading } from '@/shared/components';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { LINKS } from '../utils/constant';

export default function UserExpired() {
  const params = useSearchParams();
  const returnUrl = params.get('returnUrl');
  const router = useRouter();

  useEffect(() => {
    GlobalLoading.show();
    router.push(`${LINKS.login}?returnUrl=${returnUrl}`);
  }, []);

  return <div />;
}
